/**
 * Malosi Lure Finder — Console-style AI lure advisor
 * Two modes: free-text console or guided walkthrough
 * Thinking status messages like Claude Code
 */
(function () {
  'use strict';

  // ── Config ─────────────────────────────────────────────────
  var configEl = document.getElementById('lure-finder-config');
  var CONFIG = configEl ? JSON.parse(configEl.textContent) : {};
  var API_URL = CONFIG.apiUrl || 'https://lure-finder-api.malosi-studio.workers.dev';

  var weightsEl = document.getElementById('lure-finder-weights');
  var PRODUCT_WEIGHTS = weightsEl ? JSON.parse(weightsEl.textContent) : {};

  var swatchEl = document.getElementById('lure-finder-master-swatches');
  var MASTER_SWATCHES_RAW = swatchEl ? JSON.parse(swatchEl.textContent).filter(Boolean) : [];
  var masterSwatchMap = {};
  MASTER_SWATCHES_RAW.forEach(function (s) {
    if (!masterSwatchMap[s.handleTag]) masterSwatchMap[s.handleTag] = [];
    masterSwatchMap[s.handleTag].push(s);
  });
  var fileBaseUrl = '';
  if (MASTER_SWATCHES_RAW.length > 0 && MASTER_SWATCHES_RAW[0].swatchUrl) {
    fileBaseUrl = MASTER_SWATCHES_RAW[0].swatchUrl.substring(0, MASTER_SWATCHES_RAW[0].swatchUrl.lastIndexOf('/') + 1);
  }

  var VALID_TYPES = ['Master', 'Staple', 'Micro', 'Metal'];

  // Thinking status messages — cycles through these
  // Typewriter prompts — randomised, cycle through as placeholder examples
  var TYPEWRITER_PROMPTS = [
    'GT off the reef, topwater',
    'beginner flathead in the estuary',
    'best lure for kingfish',
    'I\'m new to lure fishing',
    'dirty water bream lures',
    'heavy tackle GT setup',
    'best walking pencil for mangroves',
    'what hooks are on the Tyrant?',
    'light tackle tailor from the beach',
    'jewfish off the rocks at night',
    'what\'s a good metal for mackerel?',
    'medium tackle kingfish from the rocks',
    'what colour for clear water?',
    'best lure under $30',
    'snapper from the rocks',
    'whiting in the estuary',
    'barramundi lures',
    'mulloway off the beach',
    'winter metals for tailor',
    'mulloway off the beach at night',
    'best metal for salmon',
    'tuna from the rocks',
    'best casting metal under $20'
  ];

  // Popular/suggested prompts shown as clickable buttons
  var POPULAR_PROMPTS = [
    'Flathead',
    'Tailor',
    'Mulloway',
    'Snapper',
    'Whiting',
    'Kingfish rocks',
    'Beginner estuary',
    'Beach casting',
    'Casting metals',
    'Light tackle bream',
    'Salmon',
    'Under $30',
    'Tuna casting',
    'Barramundi',
    'Flathead estuary',
    'Heavy tackle GT',
    'Bonito'
  ];

  var STATUS_MESSAGES = [
    // Studio & design
    'Checking Jon\'s design notebooks',
    'Reviewing Niko\'s colour guides',
    'Flipping through studio lure files',
    'Checking the prototype shelf',
    'Reading Jon\'s field test notes',
    'Reviewing Niko\'s paint samples',
    'Pulling specs from the workshop',
    'Checking the 3D print archives',
    // Technical
    'Matching lure weights to species',
    'Comparing swim actions',
    'Checking hook specs',
    'Cross-referencing rigging configs',
    'Reviewing casting distances',
    'Checking depth ratings',
    'Comparing sink rates',
    // Range & product
    'Scanning the Master range',
    'Looking through the Staples',
    'Checking Micro options',
    'Reviewing Marksman weights',
    'Pulling recommendations',
    // Fishing knowledge
    'Checking water conditions',
    'Reviewing species profiles',
    'Matching tackle class',
    'Checking Jon\'s trip reports',
    'Reviewing catch data'
  ];

  // Shuffle and pick random messages each time — never same order twice
  function getShuffledStatus() {
    var arr = STATUS_MESSAGES.slice();
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
    }
    return arr;
  }

  // ── State ──────────────────────────────────────────────────
  var allProducts = [];
  var productMap = {};
  var productsReady = false;
  var isLoading = false;
  var statusInterval = null;

  // ── Mode Detection ─────────────────────────────────────────
  // If on the find-your-lure page, show results inline.
  // If embedded elsewhere, redirect to the results page on submit.
  var RESULTS_PAGE = '/pages/find-your-lure';
  var isResultsPage = window.location.pathname.indexOf('find-your-lure') !== -1;

  // ── DOM ────────────────────────────────────────────────────
  var finder = document.getElementById('LureFinder');
  if (!finder) return;

  var outputEl = document.getElementById('LureFinderOutput');
  var inputWrap = document.getElementById('LureFinderInputWrap');
  var inputLine = document.getElementById('LureFinderInputLine');
  var inputEl = document.getElementById('LureFinderInput');
  var submitBtn = document.getElementById('LureFinderSubmit');
  var hintsEl = document.getElementById('LureFinderHints');
  var productsWrap = document.getElementById('LureFinderProducts');
  var gridEl = document.getElementById('LureFinderGrid');
  var resetBtn = document.getElementById('LureFinderReset');
  var typewriterEl = document.getElementById('LureFinderTypewriter');
  var popularEl = document.getElementById('LureFinderPopular');

  // ── Product Fetching ───────────────────────────────────────
  function fetchAllProducts() {
    var products = [], page = 1;
    function next() {
      return fetch('/collections/all/products.json?page=' + page)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.products && d.products.length > 0) {
            products = products.concat(d.products);
            if (d.products.length >= 30) { page++; return next(); }
          }
          return products;
        }).catch(function () { return products; });
    }
    return next();
  }

  function processProducts(raw) {
    var mg = {}, result = [];
    raw.filter(function (p) { return VALID_TYPES.indexOf(p.product_type) !== -1; })
      .forEach(function (p) {
        var tags = normTags(p.tags);
        if (p.product_type === 'Master') {
          var ht = fTag(tags, 'handle_');
          if (!ht) return;
          if (!mg[ht]) {
            var ct = fTag(tags, 'color_'), title = p.title;
            if (ct) title = title.replace(new RegExp('\\s*' + escRx(ct.replace('color_', '')) + '\\s*', 'i'), ' ').trim();
            // Use video thumbnail from Liquid swatch data (featured_media.preview_image)
            // instead of AJAX images[0] which misses the video preview
            var swatches = masterSwatchMap[ht] || [];
            var masterImg = (swatches.length > 0 && swatches[0].productImage) ? swatches[0].productImage : i0(p);
            mg[ht] = { id: ht, handle: p.handle, title: title, type: 'Master', tags: tags.slice(),
              price: v0p(p), compareAtPrice: v0c(p), image: masterImg, url: '/products/' + p.handle,
              available: av(p), swatches: swatches, variants: p.variants || [], options: p.options || [] };
          } else {
            tags.forEach(function (t) { if (mg[ht].tags.indexOf(t) === -1) mg[ht].tags.push(t); });
            if (av(p)) mg[ht].available = true;
          }
        } else {
          result.push({ id: p.handle, handle: p.handle, title: p.title, type: p.product_type, tags: tags,
            price: v0p(p), compareAtPrice: v0c(p), image: i0(p), url: '/products/' + p.handle,
            available: av(p), variants: p.variants || [], options: p.options || [] });
        }
      });
    Object.keys(mg).forEach(function (k) { result.push(mg[k]); });
    return result;
  }

  function buildMap(products) {
    var m = {};
    products.forEach(function (p) {
      m[p.handle] = p; m[p.id] = p;
      if (p.type === 'Master' && p.id.indexOf('handle_') === 0) m[p.id.replace('handle_', '')] = p;
    });
    return m;
  }

  function findProduct(h) {
    if (!h) return null;
    // Direct match
    if (productMap[h]) return productMap[h];
    // Try with handle_ prefix
    if (productMap['handle_' + h]) return productMap['handle_' + h];
    // Swap underscores/hyphens
    var swapped = h.indexOf('_') !== -1 ? h.replace(/_/g, '-') : h.replace(/-/g, '_');
    if (productMap[swapped]) return productMap[swapped];
    // Strip trailing letter suffix (e.g. handle_vader_260f → handle_vader_260)
    var stripped = h.replace(/([0-9])[a-z]$/i, '$1');
    if (stripped !== h) {
      if (productMap[stripped]) return productMap[stripped];
      var strippedSwap = stripped.indexOf('_') !== -1 ? stripped.replace(/_/g, '-') : stripped.replace(/-/g, '_');
      if (productMap[strippedSwap]) return productMap[strippedSwap];
    }
    // Fuzzy: try all keys that contain the core name
    var core = h.replace(/^(handle_|staple-|master-|micro-)/, '').replace(/[_-]/g, '').replace(/[a-z]$/i, '').toLowerCase();
    if (core.length >= 4) {
      for (var key in productMap) {
        var keyCore = key.replace(/^(handle_)/, '').replace(/[_-]/g, '').toLowerCase();
        if (keyCore === core) return productMap[key];
      }
    }
    return null;
  }

  // ── Helpers ────────────────────────────────────────────────
  function normTags(t) { return Array.isArray(t) ? t.map(function (s) { return s.trim(); }) : typeof t === 'string' ? t.split(',').map(function (s) { return s.trim(); }).filter(Boolean) : []; }
  function fTag(tags, pfx) { for (var i = 0; i < tags.length; i++) { if (tags[i].indexOf(pfx) === 0) return tags[i]; } return ''; }
  function v0p(p) { return p.variants && p.variants[0] ? p.variants[0].price : '0.00'; }
  function v0c(p) { return p.variants && p.variants[0] ? p.variants[0].compare_at_price : null; }
  function i0(p) { return p.images && p.images[0] ? (typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src || '') : ''; }
  function av(p) { return p.variants ? p.variants.some(function (v) { return v.available; }) : false; }
  function escRx(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function hz(s) { return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function esc(s) { return s ? String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') : ''; }
  function rsz(url, w) { return url ? url + (url.indexOf('?') !== -1 ? '&' : '?') + 'width=' + w : ''; }
  function fmt(a) { var f = CONFIG.moneyFormat || '${{amount}} AUD', n = parseFloat(a || 0).toFixed(2); return f.replace('{{amount}}', n).replace('{{amount_with_comma_separator}}', n.replace('.', ',')).replace('{{amount_no_decimals}}', Math.round(parseFloat(a || 0)).toString()).replace('{{amount_with_apostrophe_separator}}', n.replace('.', "'")); }

  // ── Output Helpers ─────────────────────────────────────────
  function addLog(label, value) {
    var el = document.createElement('p');
    el.className = 'lure-finder__log';
    el.innerHTML = '<b>' + esc(label) + ':</b> ' + esc(value);
    outputEl.appendChild(el);
  }

  function showStatus() {
    var shuffled = getShuffledStatus();
    var idx = 0;
    var wrap = document.createElement('div');
    wrap.id = 'LureFinderStatus';
    wrap.className = 'lure-finder__status';
    wrap.innerHTML = '<span class="lure-finder__status-dot"></span><span class="lure-finder__status-text">' + shuffled[0] + '</span>';
    outputEl.appendChild(wrap);

    var textEl = wrap.querySelector('.lure-finder__status-text');
    statusInterval = setInterval(function () {
      idx = (idx + 1) % shuffled.length;
      textEl.textContent = shuffled[idx];
    }, 900);
  }

  function clearStatus() {
    if (statusInterval) { clearInterval(statusInterval); statusInterval = null; }
    var el = document.getElementById('LureFinderStatus');
    if (el) el.remove();
  }

  // ── Submit ────────────────────────────────────────────────
  function submitQuery(query) {
    if (isLoading || !query.trim()) return;

    // If embedded on another page, redirect to results page
    if (!isResultsPage) {
      window.location.href = RESULTS_PAGE + '?q=' + encodeURIComponent(query.trim());
      return;
    }

    isLoading = true;
    stopTypewriter();

    inputWrap.style.display = 'none';

    hintsEl.style.display = 'none';
    productsWrap.style.display = 'none';
    gridEl.innerHTML = '';

    outputEl.innerHTML = '';
    showStatus();
    inputEl.value = ''; inputEl.style.width = '2px';

    var t0 = performance.now();
    console.log('[Lure Finder] Query: "' + query + '"');

    function go() {
      if (!productsReady) { setTimeout(go, 200); return; }

      fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: query })
      })
      .then(function (r) { if (!r.ok) throw new Error('API ' + r.status); return r.json(); })
      .then(function (data) {
        clearStatus();
        handleAPIResponse(query, data, t0);
      })
      .catch(function (err) {
        clearStatus();
        handleAPIError(query, err, t0);
      });
    }
    go();
  }

  function handleAPIResponse(query, data, t0) {
    try {
      var elapsed = ((performance.now() - t0) / 1000).toFixed(2);
      console.log('[Lure Finder] Response: ' + elapsed + 's, ' + (data.products ? data.products.length : 0) + ' products');

      outputEl.innerHTML = '';

      var queryLog = document.createElement('p');
      queryLog.className = 'lure-finder__query-log';
      queryLog.innerHTML = '<strong>You asked:</strong> ' + esc(query);
      outputEl.appendChild(queryLog);

      if (data.error) {
        console.error('[Lure Finder] API error:', data.error);
        var errMsg = document.createElement('p');
        errMsg.className = 'lure-finder__ai-message';
        errMsg.textContent = 'Something went wrong. Try again or browse our collections.';
        outputEl.appendChild(errMsg);
        inputWrap.style.display = '';
        resetBtn.style.display = '';
        isLoading = false;
  
        return;
      }

      var msg = document.createElement('p');
      msg.className = 'lure-finder__ai-message';
      var rawMsg = data.message || 'Here are your recommendations.';
      // Extract video embed from AI response or auto-detect from query
      var videoId = null;
      var videoMatch = rawMsg.match(/\[\[video:([a-zA-Z0-9_-]+)\]\]/);
      if (videoMatch) {
        videoId = videoMatch[1];
        rawMsg = rawMsg.replace(/\[\[video:[a-zA-Z0-9_-]+\]\]/g, '').trim();
      }
      // Auto-embed Briggsy's FG knot video for knot queries
      if (!videoId && /fg\s*knot|how.*tie.*knot/i.test(query)) {
        videoId = 'zyHBYyMxFkk';
      }
      var hasStockists = /\[\[stockists\]\]|\/pages\/stockists|stockists page/i.test(rawMsg);
      if (hasStockists) {
        rawMsg = rawMsg.replace(/\[\[stockists\]\]/g, '{{STOCKISTS_LINK}}').replace(/\/pages\/stockists/g, '{{STOCKISTS_LINK}}').replace(/stockists page/gi, '{{STOCKISTS_LINK}} page');
        var msgText = esc(rawMsg);
        msgText = msgText.replace(/\{\{STOCKISTS_LINK\}\}/g, '<a href="/pages/stockists" style="color:#fff;text-decoration:underline">stockists</a>');
        msg.innerHTML = msgText;
      } else {
        msg.textContent = rawMsg;
      }
      outputEl.appendChild(msg);

      // Render YouTube video embed after the AI message
      if (videoId) {
        var videoEl = document.createElement('div');
        videoEl.className = 'lure-finder__video';
        videoEl.style.cssText = 'margin:16px 0;max-width:900px';
        videoEl.innerHTML = '<div style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden;max-width:100%;border-radius:8px"><iframe src="https://www.youtube.com/embed/' + esc(videoId) + '?rel=0" style="position:absolute;top:0;left:0;width:100%;height:100%;border:0" allowfullscreen></iframe></div>';
        outputEl.appendChild(videoEl);
      }

      if (data.products && data.products.length > 0) {
        var cards = [];
        console.log('[Lure Finder] Product handles from API:', JSON.stringify(data.products));
        var matched = [];
        data.products.forEach(function (item) {
          var h = typeof item === 'object' ? item.handle : item;
          var colour = typeof item === 'object' ? item.colour : null;
          var p = findProduct(h);
          if (p) matched.push({ product: p, colour: colour });
          else console.warn('[Lure Finder] Not found:', h);
        });
        // Move sold out to end so Best Match is always available
        // Check variant-level availability for the specific recommended colour
        matched.sort(function (a, b) {
          var aVar = a.colour ? getVariantByColour(a.product, a.colour) : getFirstVariant(a.product);
          var bVar = b.colour ? getVariantByColour(b.product, b.colour) : getFirstVariant(b.product);
          var aAvail = aVar ? aVar.available : a.product.available;
          var bAvail = bVar ? bVar.available : b.product.available;
          return (aAvail === bAvail) ? 0 : aAvail ? -1 : 1;
        });
        matched.forEach(function (m, idx) {
          cards.push(renderCard(m.product, m.colour, idx === 0));
        });

        if (cards.length > 0) {
          var visibleHtml = cards.slice(0, 8).join('');
          var hiddenHtml = cards.length > 8
            ? '<div class="lure-finder__more-cards" style="display:none">' + cards.slice(8).join('') + '</div>'
            : '';
          var moreBtn = cards.length > 8
            ? '<div class="lure-finder__more-wrap"><button class="lure-finder__more-btn" id="LureFinderMore">+ More options</button></div>'
            : '';

          gridEl.innerHTML = visibleHtml + hiddenHtml;
          productsWrap.style.display = '';

          var existingMore = productsWrap.querySelector('.lure-finder__more-wrap');
          if (existingMore) existingMore.remove();
          if (moreBtn) {
            gridEl.insertAdjacentHTML('afterend', moreBtn);
            var moreBtnEl = productsWrap.querySelector('#LureFinderMore');
            if (moreBtnEl) {
              moreBtnEl.addEventListener('click', function () {
                var hidden = gridEl.querySelector('.lure-finder__more-cards');
                if (hidden) {
                  while (hidden.firstChild) gridEl.appendChild(hidden.firstChild);
                  hidden.remove();
                }
                moreBtnEl.parentElement.remove();
              });
            }
          }
        }
      }

      var hasCards = gridEl.innerHTML.trim().length > 0;
      if (!hasCards) {
        var fallback = document.createElement('div');
        fallback.className = 'lure-finder__fallback';
        fallback.innerHTML = '<p class="lure-finder__fallback-text">Try one of these instead:</p>' +
          '<div class="lure-finder__fallback-options">' +
          renderFallbackBtn('Poppers & Stickbaits', 'Show me your poppers and stickbaits') +
          renderFallbackBtn('Minnows', 'What minnows do you have?') +
          renderFallbackBtn('Sinking Stickbaits', 'Show me your sinking stickbaits') +
          renderFallbackBtn('Casting Metals', 'What metals do you have?') +
          renderFallbackBtn('Light Tackle', 'Best light tackle lures for the estuary') +
          renderFallbackBtn('Heavy Offshore', 'Heavy tackle for GT and kingfish offshore') +
          renderFallbackBtn('Beginner Setup', 'I\'m new to lure fishing, what should I start with?') +
          renderFallbackBtn('Flathead', 'Best lures for flathead in the estuary') +
          '</div>';
        outputEl.appendChild(fallback);
        fallback.addEventListener('click', function (e) {
          var btn = e.target.closest('.lure-finder__fallback-btn');
          if (btn) submitQuery(btn.getAttribute('data-query'));
        });
      }

      initATCButtons(productsWrap);
      inputWrap.style.display = '';
      resetBtn.style.display = '';
      inputEl.placeholder = 'Ask a follow-up...';
      isLoading = false;

      var headerHeight = document.querySelector('.site-header') ? document.querySelector('.site-header').offsetHeight : 0;
      var outputTop = outputEl.getBoundingClientRect().top + window.pageYOffset - headerHeight - 16;
      window.scrollTo({ top: outputTop, behavior: 'smooth' });
      inputEl.focus({ preventScroll: true });
    } catch (renderErr) {
      console.error('[Lure Finder] Render error:', renderErr);
      inputWrap.style.display = '';
      resetBtn.style.display = '';
      isLoading = false;

    }
  }

  function handleAPIError(query, err, t0) {
    var elapsed = ((performance.now() - t0) / 1000).toFixed(2);
    console.error('[Lure Finder] Error after ' + elapsed + 's:', err.message || err);
    outputEl.innerHTML = '';

    var msg = document.createElement('p');
    msg.className = 'lure-finder__ai-message';
    msg.textContent = 'Hmm, couldn\'t get a response right now. Try one of these instead:';
    outputEl.appendChild(msg);

    var fallback = document.createElement('div');
    fallback.className = 'lure-finder__fallback';
    fallback.innerHTML = '<div class="lure-finder__fallback-options">' +
      renderFallbackBtn('Poppers & Stickbaits', 'Show me your poppers and stickbaits') +
      renderFallbackBtn('Minnows', 'What minnows do you have?') +
      renderFallbackBtn('Sinking Stickbaits', 'Show me your sinking stickbaits') +
      renderFallbackBtn('Casting Metals', 'What metals do you have?') +
      renderFallbackBtn('Light Tackle', 'Best light tackle lures for the estuary') +
      renderFallbackBtn('Heavy Offshore', 'Heavy tackle for GT and kingfish offshore') +
      renderFallbackBtn('Beginner Setup', 'I\'m new to lure fishing, what should I start with?') +
      '</div>';
    outputEl.appendChild(fallback);
    fallback.addEventListener('click', function (e) {
      var btn = e.target.closest('.lure-finder__fallback-btn');
      if (btn) submitQuery(btn.getAttribute('data-query'));
    });

    inputWrap.style.display = '';
    resetBtn.style.display = '';
    inputEl.placeholder = 'Ask a follow-up...';
    isLoading = false;
  }

  // ── Reset ──────────────────────────────────────────────────
  function reset() {
    clearStatus();
    outputEl.innerHTML = '';
    inputWrap.style.display = '';
    hintsEl.style.display = '';
    resetBtn.style.display = 'none';
    productsWrap.style.display = 'none';
    gridEl.innerHTML = '';
    inputEl.value = ''; inputEl.style.width = '2px';
    inputEl.placeholder = '';
    isLoading = false;
    startTypewriter();
    finder.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ── Card Rendering (Featured Product style — pinned variant + ATC) ──
  var plusSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
  var tickSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';

  function renderCard(p, preferredColour, isFirst) {
    // Pick a specific colour variant if recommended, otherwise first available
    var variant = preferredColour ? getVariantByColour(p, preferredColour) : null;
    if (!variant) variant = getFirstVariant(p);
    var variantName = variant ? variant.name : '';
    var variantId = variant ? variant.id : '';
    var variantAvailable = variant ? variant.available : false;
    var img = variant && variant.image ? rsz(variant.image, 1080) : (p.image ? rsz(p.image, 1080) : '');
    var productUrl = p.url + (variantId ? '?variant=' + variantId : '');

    var price = renderPrice(p), badge = renderBadge(p), specs = renderSpecs(p);

    // ATC button or sold out pill
    var atcHtml = '';
    if (variantId) {
      if (variantAvailable) {
        atcHtml = '<div class="tfp-atc-wrap"><button type="button" class="tfp-atc-btn" data-variant-id="' + variantId + '" title="Add to Cart">' + plusSvg + '</button></div>';
      } else {
        atcHtml = '<div class="tfp-atc-wrap"><span class="tfp-sold-out">Sold Out</span></div>';
      }
    }

    // Variant name
    var capName = variantName ? variantName.charAt(0).toUpperCase() + variantName.slice(1) : '';
    var variantNameHtml = capName ? '<div class="tfp-variant-name">' + esc(capName) + '</div>' : '';

    return '<div class="grid__item grid-product small--one-half medium-up--one-quarter' + (isFirst ? ' tfp-best-match' : '') + '" data-product-handle="' + esc(p.handle) + '">' +
      '<div class="grid-product__content product_card">' + badge +
      '<div class="grid__item-image-wrapper">' +
      '<a href="' + esc(productUrl) + '"><div class="grid-product__image-mask"><div class="image-wrap" style="height:0;padding-bottom:100%;">' +
      (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" class="grid-product__image image-style--">' : '') +
      '</div>' + atcHtml + '</div></a>' +
      '<a href="' + esc(productUrl) + '"><div class="grid-product__meta">' + specs +
      '<div class="grid-product__title grid-product__title--heading">' + esc(p.title) + '</div>' +
      variantNameHtml +
      '<div class="grid-product__price">' + price + '</div></div></a>' +
      '</div></div></div>';
  }

  // Get the first available variant (with image if possible)
  function getFirstVariant(p) {
    // For Masters, use the first swatch entry
    if (p.type === 'Master' && p.swatches && p.swatches.length > 0) {
      // Prefer available variant
      for (var i = 0; i < p.swatches.length; i++) {
        if (p.swatches[i].available) {
          return { id: p.swatches[i].variantId, name: p.swatches[i].color, image: p.swatches[i].productImage, available: true };
        }
      }
      var s = p.swatches[0];
      return { id: s.variantId, name: s.color, image: s.productImage, available: false };
    }
    // For Staple/Micro/Metal, find colour option and first available variant
    if (p.variants && p.variants.length > 0) {
      var ci = -1;
      if (p.options) {
        for (var j = 0; j < p.options.length; j++) {
          var n = (typeof p.options[j] === 'string' ? p.options[j] : p.options[j].name || '').toLowerCase();
          if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) { ci = j; break; }
        }
      }
      // Prefer first available variant
      for (var k = 0; k < p.variants.length; k++) {
        if (p.variants[k].available) {
          var colName = ci >= 0 ? p.variants[k]['option' + (ci + 1)] || '' : '';
          var vImg = p.variants[k].featured_image ? (typeof p.variants[k].featured_image === 'string' ? p.variants[k].featured_image : p.variants[k].featured_image.src || '') : '';
          return { id: p.variants[k].id, name: colName, image: vImg, available: true };
        }
      }
      // All sold out — use first
      var v0 = p.variants[0];
      var c0 = ci >= 0 ? v0['option' + (ci + 1)] || '' : '';
      return { id: v0.id, name: c0, image: '', available: false };
    }
    return null;
  }

  // Find a specific colour variant
  function getVariantByColour(p, colour) {
    if (!colour) return null;
    var colLower = colour.toLowerCase();

    // For Masters, search swatches by colour name
    if (p.type === 'Master' && p.swatches && p.swatches.length > 0) {
      for (var i = 0; i < p.swatches.length; i++) {
        if (p.swatches[i].color && p.swatches[i].color.toLowerCase() === colLower) {
          return { id: p.swatches[i].variantId, name: p.swatches[i].color, image: p.swatches[i].productImage, available: p.swatches[i].available };
        }
      }
    }

    // For Staple/Micro/Metal, search variants by option value
    if (p.variants && p.variants.length > 0) {
      var ci = -1;
      if (p.options) {
        for (var j = 0; j < p.options.length; j++) {
          var n = (typeof p.options[j] === 'string' ? p.options[j] : p.options[j].name || '').toLowerCase();
          if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) { ci = j; break; }
        }
      }
      if (ci >= 0) {
        for (var k = 0; k < p.variants.length; k++) {
          var cv = (p.variants[k]['option' + (ci + 1)] || '').toLowerCase();
          if (cv === colLower) {
            var vImg = p.variants[k].featured_image ? (typeof p.variants[k].featured_image === 'string' ? p.variants[k].featured_image : p.variants[k].featured_image.src || '') : '';
            return { id: p.variants[k].id, name: p.variants[k]['option' + (ci + 1)], image: vImg, available: p.variants[k].available };
          }
        }
      }
    }
    return null;
  }

  function renderSpecs(p) {
    var weight = PRODUCT_WEIGHTS[p.handle] || '';
    if (p.type === 'Master' || p.type === 'Staple' || p.type === 'Micro') {
      var lt = ''; for (var i = 0; i < p.tags.length; i++) { if (p.tags[i].indexOf('type:') === 0) { lt = p.tags[i].replace('type:', '').replace(/-/g, ' '); break; } }
      if (lt) {
        var parts = [esc(p.type)];
        if (weight) parts.push(esc(weight));
        parts.push(esc(lt));
        return '<div class="grid-product__specs">' + parts.join('<span>|</span>') + '</div>';
      }
    }
    if (p.type === 'Metal') {
      var parts = ['Casting Metal'];
      if (weight) parts.splice(0, 0, esc(weight));
      return '<div class="grid-product__specs">' + parts.join('<span>|</span>') + '</div>';
    }
    return '';
  }

  function renderBadge(p) {
    // Custom label tag (e.g. _label_Coming Soon)
    if (p.tags) {
      for (var i = 0; i < p.tags.length; i++) {
        if (p.tags[i].indexOf('_label_') === 0) {
          return '<div class="grid-product__tag grid-product__tag--custom">' + esc(p.tags[i].replace('_label_', '')) + '</div>';
        }
      }
    }
    if (!p.available && p.type !== 'Master') return '<div class="grid-product__tag grid-product__tag--sold-out">Sold Out</div>';
    if (p.compareAtPrice && parseFloat(p.compareAtPrice) > parseFloat(p.price) && p.available) return '<div class="grid-product__tag grid-product__tag--sale">Sale</div>';
    return '';
  }

  function renderPrice(p) {
    var pr = fmt(p.price);
    if (p.compareAtPrice && parseFloat(p.compareAtPrice) > parseFloat(p.price)) return '<span class="grid-product__price--original">' + fmt(p.compareAtPrice) + '</span> ' + pr;
    return pr;
  }


  function renderFallbackBtn(label, query) {
    return '<button class="lure-finder__fallback-btn" data-query="' + esc(query) + '">' + esc(label) + '</button>';
  }

  // ── ATC Button handler (featured-product style) ──
  function initATCButtons(container) {
    container.querySelectorAll('.tfp-atc-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var vid = btn.getAttribute('data-variant-id');
        if (!vid) return;
        btn.disabled = true;
        btn.classList.add('tfp-loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
        })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () {
          btn.classList.remove('tfp-loading');
          btn.innerHTML = tickSvg;
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
          setTimeout(function () { btn.innerHTML = plusSvg; btn.disabled = false; }, 2000);
        })
        .catch(function () {
          btn.classList.remove('tfp-loading');
          btn.innerHTML = '!';
          setTimeout(function () { btn.innerHTML = plusSvg; btn.disabled = false; }, 2000);
        });
      });
    });
  }

  // ── Typewriter effect ──────────────────────────────────────
  var twInterval = null;
  var twTimeout = null;
  var twGeneration = 0;  // Kill stale instances

  function startTypewriter() {
    stopTypewriter();
    if (!typewriterEl) return;
    typewriterEl.style.display = '';
    if (inputEl) inputEl.style.width = '2px';

    var gen = ++twGeneration;
    var prompts = TYPEWRITER_PROMPTS.slice();
    for (var i = prompts.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = prompts[i]; prompts[i] = prompts[j]; prompts[j] = tmp;
    }
    var pIdx = 0;

    function typeNext() {
      if (gen !== twGeneration) return;  // Stale — abort
      var text = prompts[pIdx % prompts.length];
      pIdx++;
      var charIdx = 0;
      typewriterEl.textContent = '';

      twInterval = setInterval(function () {
        if (gen !== twGeneration) { clearInterval(twInterval); return; }
        charIdx++;
        typewriterEl.textContent = text.substring(0, charIdx);
        if (charIdx >= text.length) {
          clearInterval(twInterval);
          twTimeout = setTimeout(function () {
            if (gen !== twGeneration) return;
            var eraseIdx = text.length;
            twInterval = setInterval(function () {
              if (gen !== twGeneration) { clearInterval(twInterval); return; }
              eraseIdx--;
              typewriterEl.textContent = text.substring(0, eraseIdx);
              if (eraseIdx <= 0) {
                clearInterval(twInterval);
                twTimeout = setTimeout(typeNext, 400);
              }
            }, 30);
          }, 2500);
        }
      }, 60);
    }
    typeNext();
  }

  function stopTypewriter() {
    twGeneration++;
    if (twInterval) { clearInterval(twInterval); twInterval = null; }
    if (twTimeout) { clearTimeout(twTimeout); twTimeout = null; }
    if (typewriterEl) { typewriterEl.textContent = ''; typewriterEl.style.display = 'none'; }
    if (inputEl) inputEl.style.width = '100%';
  }

  // ── Popular prompts ───────────────────────────────────────
  function renderPopularPrompts() {
    if (!popularEl) return;
    var prompts = POPULAR_PROMPTS.slice();
    for (var i = prompts.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = prompts[i]; prompts[i] = prompts[j]; prompts[j] = tmp;
    }
    var shown = prompts.slice(0, 5);
    var html = '<span class="lure-finder__popular-label">Popular:</span>';
    shown.forEach(function (p) {
      html += '<button class="lure-finder__popular-btn" data-query="' + esc(p) + '">' + esc(p) + '</button>';
    });
    popularEl.innerHTML = html;

    popularEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.lure-finder__popular-btn');
      if (btn) submitQuery(btn.getAttribute('data-query'));
    });
  }

  // ── Auto-size input so cursor follows text ─────────────────
  var measureSpan = document.createElement('span');
  measureSpan.style.cssText = 'position:absolute;visibility:hidden;white-space:pre;pointer-events:none;';
  document.body.appendChild(measureSpan);

  function autoSizeInput() {
    // Copy computed styles from the actual input for accurate measurement
    var cs = window.getComputedStyle(inputEl);
    measureSpan.style.fontFamily = cs.fontFamily;
    measureSpan.style.fontSize = cs.fontSize;
    measureSpan.style.fontWeight = cs.fontWeight;
    measureSpan.style.letterSpacing = cs.letterSpacing;
    measureSpan.textContent = inputEl.value || '';
    inputEl.style.width = Math.ceil(measureSpan.offsetWidth) + 'px';
  }

  // ── Events ─────────────────────────────────────────────────
  function bind() {
    // Enter to submit
    inputEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submitQuery(inputEl.value); }
    });

    // Auto-size input as user types + hide typewriter when typing
    inputEl.addEventListener('input', function () {
      autoSizeInput();
      if (inputEl.value.length > 0) {
        stopTypewriter();
      }
    });

    // Hide typewriter on focus, restart on blur if empty
    inputEl.addEventListener('focus', function () {
      stopTypewriter();
    });
    inputEl.addEventListener('blur', function () {
      // Only restart typewriter if no results are showing (fresh state)
      var hasResults = productsWrap && productsWrap.style.display !== 'none';
      if (!inputEl.value && !isLoading && !hasResults) startTypewriter();
    });

    // Submit button
    submitBtn.addEventListener('click', function () {
      submitQuery(inputEl.value);
    });

    // Reset
    resetBtn.addEventListener('click', reset);

    // Focus input on click anywhere in console
    finder.querySelector('.lure-finder__console').addEventListener('click', function (e) {
      if (!e.target.closest('button') && !e.target.closest('input') && !e.target.closest('a') && !e.target.closest('iframe') && !e.target.closest('.lure-finder__video') && !e.target.closest('.lure-finder__ai-message') && !e.target.closest('.lure-finder__output')) inputEl.focus();
    });
  }

  // ── Init ───────────────────────────────────────────────────
  function init() {
    bind();
    renderPopularPrompts();

    // Check for ?q= parameter (redirected from embedded section)
    var urlParams = new URLSearchParams(window.location.search);
    var autoQuery = urlParams.get('q');

    if (autoQuery && isResultsPage) {
      // Immediately show loading state — don't show empty input
      inputWrap.style.display = 'none';
  
      hintsEl.style.display = 'none';
      showStatus();

      // Fire API call and product fetch in parallel
      var apiPromise = fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: autoQuery })
      }).then(function (r) { if (!r.ok) throw new Error('API ' + r.status); return r.json(); });

      var productsPromise = fetchAllProducts().then(function (raw) {
        allProducts = processProducts(raw);
        productMap = buildMap(allProducts);
        productsReady = true;
      });

      // Once both complete, render results
      Promise.all([apiPromise, productsPromise]).then(function (results) {
        var data = results[0];
        clearStatus();
        isLoading = true;
        // Reuse the same render path as submitQuery's response handler
        handleAPIResponse(autoQuery, data, performance.now());
      }).catch(function () {
        clearStatus();
        outputEl.innerHTML = '<p class="lure-finder__ai-message">Something went wrong. Please try again.</p>';
      });
      // Clean the URL without reload
      if (window.history.replaceState) {
        window.history.replaceState({}, '', RESULTS_PAGE);
      }
    } else {
      startTypewriter();
      fetchAllProducts().then(function (raw) {
        allProducts = processProducts(raw);
        productMap = buildMap(allProducts);
        productsReady = true;
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
